// extracted by mini-css-extract-plugin
module.exports = {"slideContainer":"_3QVfK","slide":"_1-4Xc"};